import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import Admin from "./Admin";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Redirect root → default language */}
        <Route path="/" element={<Navigate to="/en" />} />

        {/* Language routes */}
        <Route path="/:lang" element={<LandingPage />} />

        {/* Admin stays separate */}
        <Route path="/admin" element={<Admin />} />

        {/* 404 */}
        <Route path="*" element={<h1>404 - Page not found</h1>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;